import React, { useEffect } from 'react'
import event7 from './eventImg/event-16.webp'


const Event5 = () => {
    useEffect(() => {
        document.title = "Decarbonisation of the Buildings Sector";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>16 May 2025</h1> 
<h3 className='text-center'>Decarbonisation
of the Buildings
Sector </h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event7} alt='Decarbonisation
of the Buildings
Sector'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/3yZmbkslscZrHBc=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event5

